import React from 'react';

const AidPage = () => {
    return (
        <div>
            <article>
                <h1>Пост 1</h1>
                <section>Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci deleniti unde animi provident quibusdam non recusandae maxime tenetur vitae nulla, et tempore consequuntur! Ipsa natus asperiores totam ducimus deserunt dicta?</section>
            </article>
            <article>
                <h1>Пост 2</h1>
                <section>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Repellendus, reprehenderit adipisci, dolores vero incidunt nam sapiente omnis fugit quasi maxime mollitia, perspiciatis voluptas exercitationem illum cumque! Aspernatur temporibus odio commodi.</section>
            </article>
            <article>
                <h1>Пост 3</h1>
                <section>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ipsum laudantium optio sit iure obcaecati sed unde, doloremque at sapiente, voluptatibus qui vel. Eos iure assumenda ducimus temporibus, vitae aut!</section>
            </article>
            <article>
                <h1>Пост 4</h1>
                <section>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Veritatis, et esse libero similique laborum sed nemo ad iure architecto delectus repellat quam. Dolorum optio vel commodi eligendi eum ipsa iste!</section>
            </article>
        </div>
    );
}

export default AidPage;